// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.

export const mixinNotificationDialog = {
  methods: {
    notificationDialog: function(title, message, options = {}) {
      const h = this.$createElement;
      const elTitle = h('b-container', { props: { fluid: true } }, [
        h('b-row', [
          h('b-col', { class: ['title'] }, title)
        ])]);

      const elMessage = h('b-container', { props: { fluid: true } }, [
        h('b-row', [
          h('b-col', { class: ['message'] }, message)
        ])
      ]);

      const elBody = h('div', { class: ['content'] }, [
        elTitle, elMessage
      ]);

      return this.$bvModal.msgBoxOk(elBody, {
        ...options,
        hideHeader: true,
        centered: true,
        contentClass: 'cpax-dialog notification'
      });
    }
  }
};

export const mixinConfirmationDialog = {
  methods: {
    confirmationDialog: function(title, message, options = {}) {
      const h = this.$createElement;
      const elTitle = h('b-container', { props: { fluid: true } }, [
        h('b-row', [
          h('b-col', { class: ['title'] }, title)
        ])]);

      const elMessage = h('b-container', { props: { fluid: true } }, [
        h('b-row', [
          h('b-col', { class: ['message'] }, message)
        ])
      ]);

      const elBody = h('div', { class: ['content'] }, [
        elTitle, elMessage
      ]);

      return this.$bvModal.msgBoxConfirm(elBody, {
        ...options,
        hideHeader: true,
        centered: true,
        contentClass: 'cpax-dialog confirmation'
      });

    }
  }
}
